import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

import PreviewEmgBooking from './PreviewEmgBooking';

const PreviewEmgBookingWrapper = props => {
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
  });
  return (
    <PreviewEmgBooking
      {...props}
      printRef={contentRef}
      handlePrint={handlePrint}
    />
  );
};

export default PreviewEmgBookingWrapper;